var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"i-layout-header-trigger i-layout-header-trigger-min",staticStyle:{"height":"48px","line-height":"48px"},on:{"click":_vm.toggleCollapse}},[(_vm.store.collapse)?_c('Icon',{attrs:{"custom":"i-icon i-icon-menu-unfold"}}):_c('Icon',{attrs:{"custom":"i-icon i-icon-menu-fold"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }